import styled from 'styled-components'
import { withOpacity } from '../../helpers'

export default styled.button`
  font-family: ${ ({ theme }) => theme.fontFamily };
  font-weight: bold;
  height: 44px;
  width: 100%;
  border-radius: 44px;
  border-width: 1.5px;
  border: solid 1.5px ${ ({ theme }) => theme.colors.primary };
  color: ${ ({ theme }) => theme.colors.primary };
  background-color: ${ ({ theme }) => theme.colors.white };
  font-size: 16px;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  /* TODO Finish styles */
  &.filled {
    color: ${ ({ theme }) => theme.colors.white };
    background-color: ${ ({ theme }) => theme.colors.primary };
    transition: ease-in-out all 0.1s;
    border-color: transparent;

    &:hover {
      background-color: ${ ({ theme }) => theme.colors.primary }B3;
    }

    &:active {
      background-color: ${ ({ theme }) => theme.colors.primary }8C;
    }

    /* Disabled: the brand colour washed out to a light lilac, not grey, everywhere. */
    &:disabled {
      background-color: ${ ({ theme }) => withOpacity(theme.colors.primary, 35) };
      border-color: transparent;
    }

    .icon {
      width: 16px;
      height: auto;
      margin-right: 10px;
    }
  }

  &:disabled {
    background-color: ${ ({ theme }) => theme.colors.white }90;
    cursor: not-allowed;
  }
`

